// Stripe configuration
import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with your publishable key
// Replace with your actual Stripe publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export default stripePromise;

// Stripe configuration constants
export const STRIPE_CONFIG = {
  // Your $80/month plan price ID (you'll get this from Stripe dashboard)
  MONTHLY_PLAN_PRICE_ID: process.env.REACT_APP_STRIPE_PRICE_ID,
  
  // Webhook endpoint for handling subscription events
  WEBHOOK_ENDPOINT: '/api/stripe/webhook',
  
  // Grace period for failed payments (15 days)
  GRACE_PERIOD_DAYS: 15,
  
  // Currency
  CURRENCY: 'usd',
  
  // Plan details
  PLAN: {
    name: 'Shift Healthcare Pro',
    price: 80,
    interval: 'month',
    description: 'Full access to all dashboard features including Analytics, SEO Reports, Social Media Management, and Marketing Materials'
  }
};
